import { appToken, serverApiUrl, serverNewApiUrl, serverNodeApiUrl } from "../../index";

const token =
  "Bearer " + "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdGF0dXMiOiJVTkJMT0NLRUQiLCJpZCI6ODkyMjA2ODc5MCwibW9iaWxlIjoiJDJiJDEwJG43TEZEeTJSaXJEa1lYelNuSWlIcU90WlUzcC9SaU9jZUNmUWZLVzFQYzV6WWZabzRNZElpIiwidXNlclR5cGUiOiJBRE1JTiIsInVwZGF0ZWRBdCI6IjIwMjUtMDItMjZUMDk6MDg6MDIuNDkxWiIsImNyZWF0ZWRBdCI6IjIwMjUtMDItMjZUMDk6MDg6MDIuNDkxWiIsImlhdCI6MTc0MDU2MDg4MiwiZXhwIjoxNzQzMTg4ODgyLCJpc3MiOiJEVUJ1ZGR5In0.QzQhSkCs2juC-06HGHwBbXIDVTPLjv78715QMcXIROM";
export const fetch_category = async (insId, page, limit) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    // headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");
    headers.append("Authorization", token);

    const response = await fetch(
      serverNodeApiUrl +
      "testseries/admin/examTestType/testSeriesExamTestType/" +
      insId +
      "/" +
      page +
      "/" +
      limit,
      {
        method: "GET",
        headers,
      }
    );
    if (response.status == 200) {
      const data = await response.json();
      return {
        status: true,
        data: data,
        message: "category fetched successfully.",
      };
    } else {
      throw new Error("Something went wrong, while fetching data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};
export const add_category = async (data) => {
  try {
    // const token = `Bearer ${
    //   JSON.parse(localStorage.getItem("authState")).token
    // }`;

    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    // headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");
    headers.append("Authorization", token);

    const response = await fetch(serverNodeApiUrl + "testseries/admin/examTestType/add", {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });
    if (response.status == 200) {
      const data = await response.json();
      return data
    } else {
      throw new Error("Something went wrong, while fetching data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};
export const updateCategoryStatus = async (id, status) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    // headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");
    headers.append("Authorization", token);

    const response = await fetch(
      // serverApiUrl + "testSeriesExamTestType/updateStatus/" + id + "/" + status,
      serverNodeApiUrl +
      "testseries/admin/examTestType/updateStatus/" +
      id +
      "/" +
      status +
      "/" +
      "25",

      {
        // method: "PUT",
        method: "GET",
        headers,
      }
    );
    if (response.status == 200) {
      return { status: true, message: "category fetched successfully." };
    } else {
      throw new Error("Something went wrong, while fetching data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};
export const deleteCategory = async (id) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");

    const response = await fetch(
      serverApiUrl + "testSeriesExamTestType/delete/" + id,
      {
        method: "DELETE",
        headers,
      }
    );
    if (response.status == 200) {
      return { status: true, message: "category deleted successfully." };
    } else {
      throw new Error("Something went wrong, while deleting data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

export const countUsersAttemptedByTestSeriesExamTestTypeId = async (id) => {
  try {
    const response = await fetch(
      serverApiUrl +
      "testSeriesExamTestType/exam-test-type/" +
      id +
      "/users-attempted"
    );
    const count = await response.json();
    return { status: true, data: count };
  } catch (error) {
    console.log(error);
    return { status: false, message: error };
  }
};

export const countUsersSubmittedByTestSeriesExamTestTypeId = async (id) => {
  try {
    const response = await fetch(
      serverApiUrl +
      "testSeriesExamTestType/exam-test-type/" +
      id +
      "/users-submitted"
    );
    const count = await response.json();
    return { status: true, data: count };
  } catch (error) {
    console.log(error);
    return { status: false, message: error };
  }
};

export const getAverageScoreByTestSeriesExamTestTypeId = async (id) => {
  try {
    const response = await fetch(
      serverApiUrl +
      "testSeriesExamTestType/exam-test-type/" +
      id +
      "/average-score"
    );
    const averageScore = await response.json();
    return { status: true, data: averageScore };
  } catch (error) {
    console.log(error);
    return { status: false, message: error };
  }
};

export const getHighestScoreByTestSeriesExamTestTypeId = async (id) => {
  try {
    const response = await fetch(
      serverApiUrl +
      "testSeriesExamTestType/exam-test-type/" +
      id +
      "/highest-score"
    );
    const highestScore = await response.json();
    return { status: true, data: highestScore };
  } catch (error) {
    console.log(error);
    return { status: false, message: error };
  }
};

export const getLowestScoreByTestSeriesExamTestTypeId = async (id) => {
  try {
    const response = await fetch(
      serverApiUrl +
      "testSeriesExamTestType/exam-test-type/" +
      id +
      "/lowest-score"
    );
    const lowestScore = await response.json();
    return { status: true, data: lowestScore };
  } catch (error) {
    console.log(error);
    return { status: false, message: error };
  }
};

export const getAverageTimeTakenByTestSeriesExamTestTypeId = async (id) => {
  try {
    const response = await fetch(
      serverApiUrl +
      "testSeriesExamTestType/exam-test-type/" +
      id +
      "/average-time-taken"
    );
    const averageTimeTaken = await response.json();
    return { status: true, data: averageTimeTaken };
  } catch (error) {
    console.log(error);
    return { status: false, message: error };
  }
};

export const getPaidUsersCountByTestSeriesExamTestTypeId = async (id) => {
  try {
    const response = await fetch(
      serverApiUrl +
      "testSeriesExamTestType/exam-test-type/" +
      id +
      "/paid-users-count"
    );
    const paidUsersCount = await response.json();
    return { status: true, data: paidUsersCount };
  } catch (error) {
    console.log(error);
    return { status: false, message: error };
  }
};

//BOOKS ----->>>>>

export const add_books_category = async (data) => {
  console.log(data);
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", token);

    const response = await fetch(serverNodeApiUrl + "testseries/admin/testBook/", {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });
    if (response.status == 200) {
      const data = await response.json();
      return data;
    } else {
      throw new Error("Something went wrong, while fetching data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};
export const edit_books_category = async (name, id) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", token);


    const response = await fetch(serverNodeApiUrl + `testseries/admin/testBook/${name}/${id}`, {
      method: "PUT",
      headers,
    });
    if (response.status === 200) {
      return await response.json();
    } else {
      throw new Error("Something went wrong, while fetching data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

export const fetch_books_category = async (id) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", token);
    const response = await fetch(
      serverNodeApiUrl + "testseries/admin/testBook/" + id,

      {
        method: "GET",
        headers,
      }
    );
    if (response.status == 200) {
      const data = await response.json();
      return data;
    } else {
      throw new Error("Something went wrong, while fetching data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

export const deleteBooksCategory = async (id) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");

    const response = await fetch(serverNodeApiUrl + "testseries/admin/testBook/" + id, {
      method: "DELETE",
      headers,
    });
    if (response.status == 200) {
      return await response.json();
    } else {
      throw new Error("Something went wrong, while deleting data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

//CHAPTERS ----->>>>>

export const add_chapters_category = async (data) => {
  data.bookPageNo = parseInt(data.bookPageNo);
  console.log(data);
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", token);
    const response = await fetch(serverNodeApiUrl + "testseries/admin/chapter/", {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });
    if (response.status == 200) {
      const data = await response.json();
      return {
        status: true,
        data: data,
        message: "Chapter Added Successfully.",
      };
    } else {
      throw new Error("Something went wrong, while fetching data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};
export const edit_chapters_category = async (name, bookPageNo, id) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", token);

    const response = await fetch(
      serverNodeApiUrl + `testseries/admin/chapter/${id}`,
      {
        method: "PUT",
        body: JSON.stringify({ name, bookPageNo }),
        headers,
      }
    );
    if (response.status === 200) {
      return await response.json();
    } else {
      throw new Error("Something went wrong, while fetching data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

export const fetch_chapters_category = async (id) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");



    const response = await fetch(
      serverNodeApiUrl + "testseries/admin/chapter/byBook/" + id,

      {
        method: "GET",
        headers,
      }
    );
    if (response.status == 200) {
      const data = await response.json();
      return data;
    } else {
      throw new Error("Something went wrong, while fetching data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

export const deleteChaptersCategory = async (id) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");

    const response = await fetch(serverNodeApiUrl + "testseries/admin/chapter/" + id, {
      method: "DELETE",
      headers,
    });
    if (response.status == 200) {
      return await response.json();
    } else {
      throw new Error("Something went wrong, while deleting data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

//TOPICS --->>>>>

export const add_topics_category = async (data) => {
  data.bookPageNo = parseInt(data.bookPageNo);
  console.log(data);
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");

    const response = await fetch(serverApiUrl + "testChapter/topic/", {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });
    if (response.status == 200) {
      const data = await response.json();
      return {
        status: true,
        data: data,
        message: "Topic Added Successfully.",
      };
    } else {
      throw new Error("Something went wrong, while fetching data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};
export const edit_topics_category = async (name, bookPageNo, id) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");

    const response = await fetch(
      serverApiUrl + `testChapter/topic/${name}/${bookPageNo}/${id}`,
      {
        method: "PUT",
        headers,
      }
    );
    if (response.status === 200) {
      return {
        status: true,

        message: "Topic Added Successfully.",
      };
    } else {
      throw new Error("Something went wrong, while fetching data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

export const fetch_topics_category = async (id) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");

    const response = await fetch(
      serverApiUrl + "testChapter/topic/" + id,

      {
        method: "GET",
        headers,
      }
    );
    if (response.status == 200) {
      const data = await response.json();
      return {
        status: true,
        data: data,
        message: "topic fetched successfully.",
      };
    } else {
      throw new Error("Something went wrong, while fetching data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

export const deleteTopicsCategory = async (id) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");

    const response = await fetch(serverApiUrl + "testChapter/topic/" + id, {
      method: "DELETE",
      headers,
    });
    if (response.status == 200) {
      return { status: true, message: "Topic deleted successfully." };
    } else {
      throw new Error("Something went wrong, while deleting data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

//SUBTOPICS --->>>>>

export const add_subtopics_category = async (data) => {
  data.bookPageNo = parseInt(data.bookPageNo);
  console.log(data);
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");

    const response = await fetch(serverApiUrl + "testChapter/topic/subTopic/", {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });
    if (response.status == 200) {
      const data = await response.json();
      return {
        status: true,
        data: data,
        message: "Sub Topic Added Successfully.",
      };
    } else {
      throw new Error("Something went wrong, while fetching data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};
export const edit_subtopics_category = async (name, bookPageNo, id) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");

    const response = await fetch(
      serverApiUrl + `testChapter/topic/subTopic/${name}/${bookPageNo}/${id}`,
      {
        method: "PUT",
        headers,
      }
    );
    if (response.status === 200) {
      return {
        status: true,
        message: "Sub Topic Added Successfully.",
      };
    } else {
      throw new Error("Something went wrong, while fetching data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

export const fetch_subtopics_category = async (id) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");

    const response = await fetch(
      serverApiUrl + "testChapter/topic/subTopic/" + id,

      {
        method: "GET",
        headers,
      }
    );
    if (response.status == 200) {
      const data = await response.json();
      return {
        status: true,
        data: data,
        message: "subtopic fetched successfully.",
      };
    } else {
      throw new Error("Something went wrong, while fetching data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

export const deleteSubTopicsCategory = async (id) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");

    const response = await fetch(
      serverApiUrl + "testChapter/topic/subTopic/" + id,
      {
        method: "DELETE",
        headers,
      }
    );
    if (response.status == 200) {
      return { status: true, message: "Sub Topic deleted successfully." };
    } else {
      throw new Error("Something went wrong, while deleting data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

//SUBSUBTOPICS --->>>>>

export const add_subsubtopics_category = async (data) => {
  data.bookPageNo = parseInt(data.bookPageNo);
  console.log(data);
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");

    const response = await fetch(
      serverApiUrl + "testChapter/topic/subTopic/subTopic/",
      {
        method: "POST",
        headers,
        body: JSON.stringify(data),
      }
    );
    if (response.status == 200) {
      const data = await response.json();
      return {
        status: true,
        data: data,
        message: "Sub Topic Added Successfully.",
      };
    } else {
      throw new Error("Something went wrong, while fetching data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};
export const edit_subsubtopics_category = async (name, bookPageNo, id) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");

    const response = await fetch(
      serverApiUrl +
      `testChapter/topic/subTopic/subTopic/${name}/${bookPageNo}/${id}`,
      {
        method: "PUT",
        headers,
      }
    );

    if (response.status === 200) {
      return {
        status: true,

        message: "Sub Topic Added Successfully.",
      };
    } else {
      throw new Error("Something went wrong, while fetching data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

export const fetch_subsubtopics_category = async (id) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");

    const response = await fetch(
      serverApiUrl + "testChapter/topic/subTopic/subTopic/" + id,

      {
        method: "GET",
        headers,
      }
    );
    if (response.status == 200) {
      const data = await response.json();
      return {
        status: true,
        data: data,
        message: "sub sub topic fetched successfully.",
      };
    } else {
      throw new Error("Something went wrong, while fetching data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

export const deleteSubSubTopicsCategory = async (id) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");

    const response = await fetch(
      serverApiUrl + "testChapter/topic/subTopic/subTopic/" + id,
      {
        method: "DELETE",
        headers,
      }
    );
    if (response.status == 200) {
      return { status: true, message: "Sub Topic deleted successfully." };
    } else {
      throw new Error("Something went wrong, while deleting data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

export const save_for_later_api = async (data) => {
  console.log(data);
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");

    const response = await fetch(
      serverApiUrl +
      `testSeries/updateTestSeriesQuestionSavedForLaterStatus/${data?.status}/${data?.id}`,
      {
        method: "PUT",
        headers,
      }
    );

    if (response.status === 200) {
      return {
        status: true,

        message: "Successful!",
      };
    } else {
      throw new Error("Something went wrong!");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};



export const verify_changes_api = async (id, isInternSubmissionVerified) => {

  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    headers.append("Access-Control-Allow-Origin", serverNodeApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");
    headers.append("Authorization", token);

    const response = await fetch(
      serverNodeApiUrl +
      `testseries/admin/testSeriesQuestionLanguageVariant/updateInternSubmissionVerified`,
      {
        method: "PATCH",
        headers,
        body: JSON.stringify({
          id, isInternSubmissionVerified
        })
      }
    );

    if (response.status === 200) {
      return {
        status: true,

        message: "Successful!",
      };
    } else {
      throw new Error("Something went wrong!");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};
